<template>
    <div>
        
    </div>
</template>
<script>
import {setCookie,getCookie} from '../../assets/js/cookie.js'
export default {
    data(){
        return{
            code:'',
            state:'',
        }
    },
    mounted(){
        this.code = this.$route.query.code;
        this.state = this.$route.query.state;
        this.getDate();
    },
    methods:{
        getDate(){
            let code = this.$route.query.code == undefined ? '' : this.$route.query.code;
            let state = this.$route.query.state == undefined ? '' : this.$route.query.state;
            let url = '';
            // console.log('code=====' + code);
            if(code == ''){
                location.href = 'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=212143&redirect_uri=http://www.2office.cn/qqtoken&state=qqlogin';
            }
            else{
                let that = this;
                if('qqlogin' == state){
                    
                    let data = {'code':code}
                    this.$ajax({
                        method: 'post',
                        url: this.GLOBAL.serverSrc + '/login/access_token.json',
                        data: data,
                        headers: {
                            'Content-Type': 'application/json; charset=UTF-8'
                        }
                    }).then(function(res) {
                        if('0000000' == res.data.code)
                        {
                            that.GLOBAL.token = res.data.token
                            setCookie('2officesessionid',res.data.token,60*60*10)
                            location.href = '/main';
                        }
                        else if("0010023" == res.data.code){
                            that.GLOBAL.token = res.data.token
                            setCookie('2officesessionid',res.data.token,60*60*10)
                            location.href = '/main';
                        }
                        else
                        {
                            alert(res.data.msg)
                        }
                    })
                }
            }
            // let data = {'openid':'A9F7B4B2EEB1D7D122C0E0432D856D85'};
            // let that = this;
            // this.$ajax({
            //     method: 'post',
            //     url: this.GLOBAL.serverSrc + '/login/access_token.json',
            //     data: data,
            //     headers: {
            //         'Content-Type': 'application/json; charset=UTF-8'
            //     }
            // }).then(function(res) {
            //     if('0000000' == res.data.code)
            //     {
            //         alert("验证成功，登录")
            //         that.GLOBAL.token = res.data.token
            //         setCookie('2officesessionid',res.data.token,60*60*10)
            //         location.href = '/main';
            //     }
            //     else
            //     {
            //         alert(res.data.msg)
            //     }
            // })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/qq/qqtoken.vue